/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, string, func } from 'prop-types';
import { connect } from 'react-redux';

import p from 'polyglot/polyglot';

import {
  REQUEST_CODE_SUCCESS,
  VERIFY_CODE_SUCCESS,
  requestCode as requestCodeAction,
  verifyCode as verifyCodeAction,
} from 'actions/user';

import StepHeader from 'components/StepHeader/StepHeader';
import RequestCode from './RequestCode/RequestCode';
import VerifyCode from './VerifyCode/VerifyCode';

import styles from './update-phone.scss';

/**
 * This is the UpdatePhone component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class UpdatePhone extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    auth: shape({
      token: string.isRequired,
    }).isRequired,
    requestCode: func.isRequired,
    verifyCode: func.isRequired,
  };

  /**
   * Create UpdatePhone.
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      requestCode: true,
      verifyCode: false,
      phoneVerified: false,
    };
  }

  requestCode = data => {
    const { auth: { token }, requestCode } = this.props;

    requestCode(token, data).then(({ type }) => {
      if (type === REQUEST_CODE_SUCCESS) {
        this.setState({
          requestCode: false,
          verifyCode: true,
        });
      }
    });
  };

  verifyCode = data => {
    const { auth: { token }, verifyCode } = this.props;

    verifyCode(token, data).then(({ type }) => {
      if (type === VERIFY_CODE_SUCCESS) {
        this.setState({
          requestCode: false,
          verifyCode: false,
          phoneVerified: true,
        });
      }
    });
  };

  tryAgain = () => {
    this.setState({
      requestCode: true,
      verifyCode: false,
      phoneVerified: false,
    });
  };

  renderContent() {
    const { verifyCode, phoneVerified } = this.state;

    if (phoneVerified) {
      return (
        <div className={styles.content}>
          <StepHeader
            title={p.t('profile.update_phone.phone_verified.title')}
            description={p.t('profile.update_phone.phone_verified.description')}
            current={3}
            total={3}
          />
        </div>
      );
    }

    if (verifyCode) {
      return (
        <div className={styles.content}>
          <StepHeader
            title={p.t('signup.verify_code.title')}
            current={2}
            total={3}
          />
          <VerifyCode onSubmit={this.verifyCode} />

          <footer className={styles.footer}>
            <p>{p.t('signup.verify_code.resend.question')}</p>

            <button className={styles.resendLink} onClick={this.tryAgain}>
              {p.t('signup.verify_code.resend.link')}
            </button>
          </footer>
        </div>
      );
    }

    return (
      <div className={styles.content}>
        <StepHeader
          title={p.t('signup.request_code.title')}
          description={p.t('signup.request_code.description')}
          current={1}
          total={3}
        />
        <RequestCode onSubmit={this.requestCode} />
      </div>
    );
  }

  /**
   * Render UpdatePhone.
   *
   * @return {Object}
   */
  render() {
    return (
      <article className={styles.wrapper}>
        <div className={styles.row}>{this.renderContent()}</div>
      </article>
    );
  }
}

export default connect(({ auth }) => ({ auth }), {
  requestCode: requestCodeAction,
  verifyCode: verifyCodeAction,
})(UpdatePhone);
